import { Item, Root, Trigger } from '@radix-ui/react-accordion';
import { useState } from 'react';

import Button from 'molecules/Button';
import Icon from 'molecules/Icon';
import Link from 'molecules/Link';

import Content from 'layout/header/components/mobileNavigation/accordionContent';
import MainMobileAccordion from 'layout/header/components/mobileNavigation/mainMobileAccordion';
import { closeMobileMenu } from 'layout/header/store';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

interface MobileNavigationProps {
  menuItems?: HeaderNavigation[];
  callToAction?: MenuItem[];
  loginLink?: {
    label: string;
    link: string;
  }[];
}

const MobileNavAccordion: FC<{ item: HeaderNavigation }> = ({ item }) =>
  item.megaMenu?.menu?.length ? (
    <>
      <Trigger asChild>
        <button className="group flex w-full items-center justify-between gap-1 p-3 text-xl leading-[30px] text-white transition-colors data-[state=open]:text-primary-100">
          {item?.label}
          <Icon icon="chevron-down" size={24} className="-rotate-90 group-aria-[expanded=true]:rotate-0" />
        </button>
      </Trigger>
      <Content {...item.megaMenu} />
    </>
  ) : (
    <Link
      href={item?.link || 'https://www.prismatic.com'}
      className="group flex w-full items-center justify-between gap-1 p-3 text-xl text-white"
      onClick={() => closeMobileMenu()}
      enablePreview={false}
    >
      {item?.label}
    </Link>
  );

const MobileNavigation: FC<MobileNavigationProps> = ({ menuItems, callToAction, loginLink }) => {
  const [openSection, setOpenSection] = useState<string>('');

  return (
    <MainMobileAccordion>
      <Root
        type="single"
        collapsible
        value={openSection}
        onValueChange={setOpenSection}
        className="flex-1 overflow-y-auto"
      >
        {hasArrayValues(menuItems) &&
          menuItems.map(mainItem => (
            <Item
              key={mainItem.label}
              value={mainItem.label || ''}
              className="border-b border-white/10 data-[state=open]:border-b-0"
            >
              <MobileNavAccordion item={mainItem} />
            </Item>
          ))}
      </Root>
      <div className="mt-auto flex w-full shrink-0 flex-col gap-4 border-t border-white/10 pb-[max(16px,env(safe-area-inset-bottom))] pt-6">
        {hasArrayValues(callToAction) &&
          callToAction.map((button, index) => (
            <Link key={button.label} href={button.link || 'https://www.prismatic.com'} enablePreview={false}>
              <Button
                label={button.label}
                hierarchy={index === 0 ? 'secondary' : 'primary'}
                className="w-full md:w-full"
                onClick={() => closeMobileMenu()}
              />
            </Link>
          ))}
        {hasArrayValues(loginLink) &&
          loginLink.map(link => (
            <Link
              key={link.label}
              href={link.link}
              className="text-center font-roboto text-md font-medium text-primary-1400 hover:text-primary-1600"
              onClick={() => closeMobileMenu()}
              enablePreview={false}
            >
              {link.label}
            </Link>
          ))}
      </div>
    </MainMobileAccordion>
  );
};

export default MobileNavigation;
